<p>dashboard-component-editor works!</p>
